import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useClient } from './useClient';
import { AxiosError } from 'axios';
import { ErrorResponse } from '@hud/portal-dtos/src/lib/webapp-common.dto';
import { ISSUES_BASE } from '../consts';
import {
  EndpointSettingsAction,
  UpdateEndpointSettingsPayload,
  UpdateEndpointSettingsResponse,
} from '@hud/portal-dtos/issues.dtos';
import useEnvironment from './useEnvironment';
import { HEADS_UP_SETTINGS_ID } from './useHeadsUpSettingsQuery';
import { ISSUES_ID } from './useIssues';

interface EndpointSettingsMutationParams {
  endpointId: number;
  serviceId: number;
  action: EndpointSettingsAction;
}

export default function useEndpointSettingsMutation() {
  const { client } = useClient();
  const reactQueryClient = useQueryClient();
  const { environment } = useEnvironment();

  return useMutation<
    UpdateEndpointSettingsResponse,
    AxiosError<ErrorResponse>,
    EndpointSettingsMutationParams
  >({
    mutationFn: async ({ endpointId, serviceId, action }) => {
      if (!environment) {
        throw new Error('Environment not found');
      }

      const params: UpdateEndpointSettingsPayload = {
        endpointId,
        serviceId,
        environmentName: environment.name,
        action,
      };

      const response = await client.put<UpdateEndpointSettingsResponse>(
        `${ISSUES_BASE}/endpoints-settings`,
        params,
      );
      return response.data;
    },

    onSuccess: () => {
      reactQueryClient.invalidateQueries({ queryKey: [HEADS_UP_SETTINGS_ID] });
      reactQueryClient.invalidateQueries({ queryKey: [ISSUES_ID] });
    },
  });
}
